import { useState, useEffect, useRef } from "react";
import { GetMocktestQuestion } from "../../../Client/request";

export const useSpeakingQuestion = (quest, onQuestionLoaded, cachedQuestionData = null) => {
  const [questData, setQuestData] = useState(cachedQuestionData || null);
  const [loading, setLoading] = useState(!cachedQuestionData);
  const [imageLoading, setImageLoading] = useState(true);
  const onQuestionLoadedRef = useRef(onQuestionLoaded);

  // Update ref when callback changes
  useEffect(() => {
    onQuestionLoadedRef.current = onQuestionLoaded;
  }, [onQuestionLoaded]);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      setImageLoading(true);
      if (cachedQuestionData) {
        setQuestData(cachedQuestionData);
        setLoading(false);
        onQuestionLoadedRef.current?.();
        return;
      }

      setQuestData(null);
      GetMocktestQuestion(quest?.QuestionId).then((res) => {
        if (res.data) {
          setQuestData(res.data);
          setLoading(false);
          onQuestionLoadedRef.current?.();
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        console.error('Error fetching question:', error);
        setLoading(false);
      });
    }
  }, [quest, cachedQuestionData]);

  return { questData, loading, imageLoading, setImageLoading };
};
